import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Grid, Modal } from "@mui/material";
import { Progress, Table, Tag, Tooltip } from "antd";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { FiDownload } from "react-icons/fi";
import LoadingBackdrop from "../components/general/LoadingBackdrop";
import NunitoText from "../components/general/NunitoText";
import ReusableButton from "../components/general/ReusableButton";
import AddNewCompetitionForCertificateModal from "../components/modal/AddNewCompetitionForCertificateModal";
import ConfirmDeleteModal from "../components/modal/ConfirmDeleteModal";
import NewCertificateModal from "../components/modal/NewCertificateModal";
import ViewConfiguredNewCompetitionsForPrintCertificate from "../components/modal/ViewConfiguredNewCompetitionsForPrintCertificate";
import { isAdmin } from "../functions/checkrole";
import { deleteCertificate } from "../functions/deleteData";
import { cancelAction } from "../functions/general";
import { downloadCertificate, listCertificates } from "../functions/getData";
import {
  addNewCompetitionInPrintCertificates,
  generateNewCertificates,
} from "../functions/postData";
import { showNotification } from "../functions/snackbar";

const PrintCertificate = () => {
  document.title = "Print Certificate";
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [onApprove, setOnApprove] = useState(false);
  const [onAddCompetition, setOnAddCompetition] = useState(false);
  const [onViewConfiguredCompetitions, setOnViewConfiguredCompetitions] =
    useState(false);
  const cancelApprove = () => cancelAction(setOnApprove);
  const cancelAddCompetition = () => cancelAction(setOnAddCompetition);
  const cancelViewConfiguredCompetitionsFunction = () =>
    cancelAction(setOnViewConfiguredCompetitions);
  const [data, setData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15); // can also use per_page from backend
  const [totalItems, setTotalItems] = useState(0);
  const [onDelete, setOnDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleDeleteRow = async (id) => {
    setLoading(true);
    deleteCertificate({ ids: [id] }).then((res) => {
      listData(currentPage);
      setOnDelete(false);
      showNotification("success", res.message, enqueueSnackbar, closeSnackbar);
    });
  };

  const handleDownload = async (id) => {
    setLoading(true);
    downloadCertificate(id).then((res) => {
      const link = document.createElement("a");
      link.href = res?.download_link;
      link.download = "";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoading(false);
    });
  };
  const columns = [
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,

            backgroundClip: "padding-box",
          }}
        >
          Print ID
        </span>
      ),
      dataIndex: "printId",
      key: "printId",
    },
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,
            backgroundClip: "padding-box",
          }}
        >
          Round Type
        </span>
      ),
      dataIndex: "round_type",
      key: "round_type",
    },
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,

            backgroundClip: "padding-box",
          }}
        >
          Batch Name
        </span>
      ),
      dataIndex: "batch_name",
      key: "batch_name",
    },
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,

            backgroundClip: "padding-box",
          }}
        >
          Specifications
        </span>
      ),
      dataIndex: "specifications",
      key: "specifications",
    },
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,

            backgroundClip: "padding-box",
          }}
        >
          Generated by
        </span>
      ),
      dataIndex: "generatedBy",
      key: "generatedBy",
    },
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,

            backgroundClip: "padding-box",
          }}
        >
          Generated At
        </span>
      ),
      dataIndex: "generatedAt",
      key: "generatedAt",
    },
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,

            backgroundClip: "padding-box",
          }}
        >
          Expires At
        </span>
      ),
      dataIndex: "expiresAt",
      key: "expiresAt",
    },
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,
            backgroundClip: "padding-box",
          }}
        >
          Status
        </span>
      ),
      dataIndex: "status",
      width: 70,
      key: "status",
      render: (status, data) => {
        if (status !== "In Progress") {
          return (
            <Grid alignItems={"center"} display={"flex"} gap={5}>
              <Tag
                color={
                  status === "Active" || status === "Ready" ? "green" : "red"
                }
              >
                {status}
              </Tag>
              <FiDownload
                onClick={() => handleDownload(data?.printId)}
                className="action-icons download-icon"
                style={{ cursor: "pointer", stroke: "#144A94" }}
              />
              <DeleteIcon
                onClick={() => {
                  setSelectedId(data?.printId);
                  setOnDelete(true);
                }}
                className="action-icons delete-icon"
                style={{ cursor: "pointer", fill: "#E83042" }}
              />
            </Grid>
          );
        } else if (status === "In Progress") {
          return (
            <Progress
              percent={data?.progress}
              strokeColor="#144A94"
              showInfo={false}
            />
          );
        }
      },
    },
  ];

  const approveFunction = (formData) => {
    setLoading(true);
    // Security: Default to true if user is not admin, otherwise use the value from form
    const includeStats = isAdmin()
      ? formData?.includeStats !== undefined
        ? formData.includeStats
        : true
      : true;

    let payload = {
      mode: formData?.mode,
      is_team_round: formData?.roundType,
      competition: formData?.competition?.value,
      country: formData?.country?.value,
      organization: Array.isArray(formData?.organization)
        ? formData?.organization?.map((org) => org.value)
        : formData?.organization?.value,
      province: Array.isArray(formData?.province)
        ? formData?.province?.map((p) => p.value)
        : formData?.province?.value,
      school: Array.isArray(formData?.school)
        ? formData?.school?.map((s) => s.value)
        : formData?.school?.value,
      grade: Array.isArray(formData?.grade)
        ? formData?.grade?.map((g) => g.value)
        : formData?.grade?.value,
      participant_index: Array.isArray(formData?.indexNumber)
        ? formData?.indexNumber?.map((i) => i.value)
        : formData?.indexNumber?.value,
      participant_name: Array.isArray(formData?.studentName)
        ? formData?.studentName?.map((s) => s.value)
        : formData?.studentName?.value,
      award: formData?.awards?.map((award) => award.value),
      private_options: formData?.show?.value,
      sorting_options: formData?.selectedSortingOptions.map((option) => ({
        field: option.groupValue,
        direction: option.value,
      })),
      include_stats: includeStats,
    };

    // Filter out null, undefined, and empty string values
    const filteredPayload = Object.fromEntries(
      Object.entries(payload).filter(([key, value]) => {
        if (
          key === "sorting_options" ||
          key === "award" ||
          key === "organization" ||
          key === "province" ||
          key === "school" ||
          key === "grade" ||
          key === "participant_index" ||
          key === "participant_name"
        ) {
          // Special handling for array fields
          return Array.isArray(value) && value.length > 0;
        }
        return value != null && value !== "";
      })
    );

    generateNewCertificates(filteredPayload).then((res) => {
      if (res.errors) {
        showNotification("error", res.errors, enqueueSnackbar, closeSnackbar);
      } else {
        showNotification(
          "success",
          res.message,
          enqueueSnackbar,
          closeSnackbar
        );
        listData(1);
      }
    });

    setLoading(false);
    setOnApprove(false);
  };

  const formatData = (data) => {
    let formattedData;

    formattedData = data?.map((el) => {
      const specifications = el?.specifications;
      return {
        printId: el?.id,
        batch_name: el?.batch_name,
        round_type: el?.round_type,
        specifications: (
          <Tooltip
            placement="right"
            color="white"
            popupStyle={{
              borderRadius: 8,
              boxShadow: "#fff",
              padding: 12,
              color: "#1f1f1f",
              fontSize: 13,
              maxWidth: 300, // optional: to keep it tidy
            }}
            title={
              <div
                style={{
                  padding: 12,
                  borderRadius: 8,
                  color: "#1f1f1f",
                  minWidth: 200,
                }}
              >
                <div style={{ marginBottom: 8 }}>
                  {Object.entries(specifications || {}).map(([key, value]) => {
                    // Skip null, undefined, empty string, or empty arrays
                    if (
                      value == null ||
                      value === "" ||
                      (Array.isArray(value) && value.length === 0)
                    ) {
                      return null;
                    }

                    // Helper to check if value is a plain object (not array, Date, RegExp, etc)
                    const isPlainObject = (val) => {
                      return (
                        typeof val === "object" &&
                        val !== null &&
                        !Array.isArray(val) &&
                        val.constructor === Object
                      );
                    };

                    // Skip plain objects - they can't be rendered directly
                    if (isPlainObject(value)) {
                      return null;
                    }

                    // Handle sorting_options specially
                    if (key === "sorting_options" && Array.isArray(value)) {
                      return (
                        <div key={key}>
                          <div
                            style={{
                              fontWeight: 600,
                              color: "#2f54eb",
                              marginBottom: 4,
                              marginTop: 8,
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>Field</span>
                            <span>Direction</span>
                          </div>
                          {value.map((opt, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: 2,
                              }}
                            >
                              <span>{opt?.field || ""}</span>
                              <span>{opt?.direction || ""}</span>
                            </div>
                          ))}
                        </div>
                      );
                    }

                    // Handle array values
                    if (Array.isArray(value)) {
                      // Convert array items to strings, handling objects if needed
                      const displayValue = value
                        .map((item) => {
                          if (item == null) {
                            return "";
                          }
                          if (isPlainObject(item)) {
                            // If it's an object, try to get a meaningful string representation
                            return (
                              item.label || item.value || JSON.stringify(item)
                            );
                          }
                          return String(item);
                        })
                        .filter((str) => str !== "") // Remove empty strings
                        .join(", ");

                      if (!displayValue) {
                        return null;
                      }

                      return (
                        <div
                          key={key}
                          style={{ color: "#2f54eb", fontWeight: 600 }}
                        >
                          <strong>
                            {key.charAt(0).toUpperCase() +
                              key.slice(1).replace(/_/g, " ")}
                            :
                          </strong>{" "}
                          <span style={{ color: "#000" }}>{displayValue}</span>
                        </div>
                      );
                    }

                    // Handle non-array, non-object values (primitives)
                    return (
                      <div
                        key={key}
                        style={{ color: "#2f54eb", fontWeight: 600 }}
                      >
                        <strong>
                          {key.charAt(0).toUpperCase() +
                            key.slice(1).replace(/_/g, " ")}
                          :
                        </strong>{" "}
                        <span style={{ color: "#000" }}>{String(value)}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            }
          >
            <InfoCircleOutlined
              style={{ cursor: "pointer", color: "#595959" }}
            />
          </Tooltip>
        ),
        generatedBy: el?.generated_by,
        generatedAt: el?.generated_at,
        expiresAt: el?.expires_at,
        status: el?.status,
        canDownload: el?.show_donwload_button,
        canDelete: el?.show_delete_button,
        progress: el?.progress,
      };
    });
    return formattedData;
  };

  const listData = (page) => {
    setLoading(true);
    listCertificates(page).then((res) => {
      const { current_page, total, per_page } = res?.meta || {};

      setData(formatData(res?.data));
      setPageSize(per_page || 10);
      setTotalItems(total || 0);
      setCurrentPage(current_page);
    });
    setLoading(false);
  };

  const approveNewCompetitionFunction = (formData) => {
    setLoading(true);
    addNewCompetitionInPrintCertificates(formData)
      .then((res) => {
        showNotification(
          "success",
          res.message,
          enqueueSnackbar,
          closeSnackbar
        );
        listData(1);
      })
      .catch((err) => {
        showNotification("error", err.message, enqueueSnackbar, closeSnackbar);
      })
      .finally(() => {
        setLoading(false);
        setOnAddCompetition(false);
      });
  };

  useEffect(() => {
    listData(1);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (data.some((row) => row.status === "In Progress")) {
        listData(currentPage);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [data]);

  return (
    <Box className="wrapperBox">
      <LoadingBackdrop loading={loading} />
      <Grid
        className="firstRowContainer"
        container
        justifyContent="space-between"
      >
        <div className="dashboardAndSelfBtnDiv">
          <ReusableButton
            text="Dashboard"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            width={125}
            br={18}
            to="/dashboard"
            iconType="home"
          />
          <ChevronRightIcon />
          <ReusableButton
            text="Print Certificate"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            br={18}
            onClick={() => {}}
          />
        </div>
      </Grid>
      <Grid className="tableContainer" container flexDirection={"column"}>
        <Grid
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <NunitoText
            value="Print Certificates"
            fontSize={40}
            align={"left"}
            fontWeight={700}
            marginBottom={40}
            italic
            color="#144A94"
          />
          <div>
            {isAdmin() && (
              <ReusableButton
                marginBottom={40}
                text="Add New Competition"
                fontSize={15}
                bgColor="#5E75C3"
                height={46}
                marginRight={20}
                iconType="add"
                onClick={() => setOnAddCompetition(true)}
              />
            )}
            {isAdmin() && (
              <ReusableButton
                marginBottom={40}
                text="View Configured Competitions"
                fontSize={15}
                bgColor="#5E75C3"
                height={46}
                marginRight={20}
                iconType="preview"
                onClick={() => setOnViewConfiguredCompetitions(true)}
              />
            )}
            <ReusableButton
              marginBottom={40}
              text="Add Print"
              fontSize={15}
              bgColor="#5E75C3"
              height={46}
              marginRight={20}
              iconType="add"
              onClick={() => setOnApprove(true)}
            />
          </div>
        </Grid>
        <Table
          columns={columns}
          dataSource={data}
          showSorterTooltip={false}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalItems,

            onChange: (page, pageSize) => {
              listData(page, pageSize);
            },
          }}
        />

        <Modal open={onApprove} onClose={() => cancelApprove()}>
          <NewCertificateModal
            approveFunction={approveFunction}
            cancelApprove={cancelApprove}
          />
        </Modal>
        <Modal
          open={onViewConfiguredCompetitions}
          onClose={() => setOnViewConfiguredCompetitions(false)}
        >
          <ViewConfiguredNewCompetitionsForPrintCertificate
            cancelApprove={cancelViewConfiguredCompetitionsFunction}
          />
        </Modal>
        {isAdmin() && (
          <Modal open={onAddCompetition} onClose={() => cancelAddCompetition()}>
            <AddNewCompetitionForCertificateModal
              approveFunction={approveNewCompetitionFunction}
              cancelApprove={cancelAddCompetition}
            />
          </Modal>
        )}
      </Grid>
      <Modal open={onDelete} onClose={() => setOnDelete(false)}>
        <>
          <ConfirmDeleteModal
            cancelDelete={() => setOnDelete(false)}
            deleteFunction={handleDeleteRow}
            id={selectedId}
            objectName={"this Print"}
          />
        </>
      </Modal>
    </Box>
  );
};

export default PrintCertificate;
